import {useGameStore} from '../../store/GameStoreContext'
import {PlayerColor, TradeResponseStatus} from '@colonist/game-states'
import {useMemo} from 'react'

export const useIsPlayerTakingAction = (playerColor: PlayerColor) => {
    const isTakingAction = useGameStore((state) => state.gameState.playerStates[playerColor]?.isTakingAction ?? false)
    const tradeState = useGameStore((state) => state.gameState.tradeState)

    return useMemo(() => {
        if(isTakingAction) return true

        for(const activeTradeOffer of Object.values(tradeState.activeOffers)) {
            if(activeTradeOffer === undefined) continue

            if(activeTradeOffer.creator === playerColor) return true
            if(activeTradeOffer.playersCreatingCounterOffer[playerColor] === true) return true
            if(activeTradeOffer.playerResponses[playerColor] === TradeResponseStatus.PendingResponse) return true
        }

        return false
    }, [isTakingAction, tradeState])
}
